document.addEventListener('DOMContentLoaded', (event) => {
  var tl = gsap.timeline();

  tl.from('#animated-logo', {
    delay: 0.6,
    duration: 0.4,
    opacity: 0,
    ease: 'power3-out',
  })
    .to('#animated-logo', {
      delay: 1.2,
      duration: 0.8,
      opacity: 0,
      yPercent: -100,
      ease: 'back.out',
    })
    .to('#animated-logo', {
      duration: 0,
      width: 0,
    })
    .to(
      '#animated-bg',
      {
        duration: 0.4,
        height: 0,
        ease: 'power3.out',
      },
      '-=0.3'
    )
    .call(showBody, [], '-=0.8')
    .from('#logo-with-rays', {
      opacity: 0,
      yPercent: 10,
    })
    .to('#logo-with-rays', {
      opacity: 1,
      duration: 0.3,
      ease: 'back.out',
    })
    .fromTo(
      '#slogan',
      {
        opacity: 0,
        yPercent: 100,
      },
      {
        opacity: 1,
        duration: 0.35,
        ease: 'power3.out',
      },
      '-=0.3'
    );
});

function showBody() {
  document.getElementById('all-content').style.overflow = 'scroll';
}